import React, { useState, useEffect, Fragment } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Header from "../components/headerNA";
import Footer from "../components/footer";
import { enviarCorreoAceptacion, obtenerScore, getDocuments, finalUpdateScore } from '../services/api.js'
import { configStyle, obtenerValorConfig, obtenerValorUser, replaceValue } from '../services/configStyle'
import Loader from "../components/loader";
import { isMobile, isIOS } from 'react-device-detect';
import { hayExcepcion, status, statusError, statusData, regresarJson, sendData, evento, validarRedireccionamiento } from '../services/data';
import Ayuda from './ayuda';

let Finalizado = (props) => {
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [apiKey, setApiKey] = useState('')
    const [uuid, setUuid] = useState('-')
    const [dataUser, setDataUser] = React.useState([])
    const [dataOtorgante, setDataOtorgante] = useState([])
    const [dataFace, setDataFace] = useState({});
    const [isFlag, setFlag] = useState('');
    const { ruta } = useParams();
    const [showHelp, setShowHelp] = useState(false);
    const [contador, setContador] = useState(0);
    const intentos = 15;
    const [uuidTrx, setUuidTrx] = useState('-');
    const [finished, setFinished] = useState(false);
    // const [respuestaFinalLifeCycle, setRespuestaFinalLifeCycle] = useState(false)
    // const [respuestaFinalPivote, setRespuestaFinalPivote] = useState(false)

    useEffect(() => {
        let apikeyOtorgante = localStorage.getItem("apikeyOtorgante")
        if (apikeyOtorgante !== null) {
            setApiKey(apikeyOtorgante)
        }

        let uuidUser = localStorage.getItem("uuidUser")
        if (uuidUser != null) {
            setUuid(uuidUser)
        }

        let uuidTrx = localStorage.getItem("uuidTrx")
        if (uuidTrx) {
            setUuidTrx(uuidTrx)
        }
        let dataUserLS = localStorage.getItem("data_user")
        if (dataUserLS != null) {
            setDataUser(JSON.parse(dataUserLS))
        }
        let dataOtorganteLS = localStorage.getItem("dataOtorgante")
        if (dataOtorganteLS != null) {
            setDataOtorgante(JSON.parse(dataOtorganteLS))
        }
        let dataFaceLS = localStorage.getItem("face")
        if (dataFaceLS != null) {
            setDataFace(JSON.parse(dataFaceLS))
        }

        actualizarScore()
        status("consulta_score_page", "Validación de Score")

    }, [])

    useEffect(() => {
        localStorage.setItem("data_user", JSON.stringify(dataUser))
    }, [dataUser])

    useEffect(() => {
        configStyle(dataOtorgante)
    }, [dataOtorgante])

    useEffect(() => {
        //console.log("contador", contador);
        setTimeout(() => {
            if (!isFlag && parseInt(contador) < intentos && parseInt(contador) > 0) {
                obtenerScoreUser()
            } else {
                if (parseInt(contador) > intentos) {
                    console.log("sin dato en bandera");
                    statusError("score_check", "Sin valores en el score", "error")
                }
                setLoading(false)
            }
        }, 200);

    }, [contador])

    // useEffect(() => {
    //     if(respuestaFinalLifeCycle && respuestaFinalPivote) window.close()
    // }, [respuestaFinalLifeCycle, respuestaFinalPivote]);

    const obtenerScoreUser = async () => {
        let uuidUser = localStorage.getItem("uuidUser")
        let tipo = '';
        let informacion = {};
        //console.log("entre a obtener");
        obtenerScore(uuidUser, !isMobile).then((response) => {
            //console.log("Response200",response);
            if (response.status === 200) {
                informacion.status = response.status;
                informacion.payload = response.data.payload;
                evento('Obtener Score', 'Success', informacion, true);
                if (response.data.payload.flag) {
                    let data = { flag: response.data.payload.flag }
                    statusData("consulta_score", data);
                    let b = (response.data.payload.flag).toUpperCase()
                    setFlag(b);
                    let campos = JSON.stringify(response.data.payload.Fields)
                    localStorage.setItem("fields", campos);
                    localStorage.setItem("flag", response.data.payload.flag);
                } else {
                    console.log("sin bandera");
                    setContador(parseInt(contador) + 1)
                }
            }
        }).catch((error) => {
            console.log("errorBandera:", error);
            setContador(parseInt(contador) + 1)
            if (error.response) {
                let { data: { message }, status } = error.response
                informacion.mensaje = message;
                informacion.status = status;
                tipo = 'Error';
            } else {
                informacion.error = error.toString();
                tipo = 'Exception';
            }
            evento('Obtener Score', tipo, informacion, false);

        });
    }

    const statusF = (error) => {
        //console.log("entre a status ine");
        statusError("email_check", error, "error")
    }

    const enviarCorreo = (e) => {
        let tipo = '';
        let informacion = {};
        let objeto = {};
        if (isFlag === "GREEN") {
            objeto.tipo_envio = 'COMPLETO';
            // objeto.estado_flujo = "COMPLETADO"
        } else {
            objeto.tipo_envio = 'SEMAFORO';
            // objeto.estado_flujo = "CANCELADO"
        }
        objeto.semaforo = isFlag.toLocaleLowerCase();
        objeto.uuidUser = uuid;
        objeto.name = obtenerValorUser(dataUser, "nombreCompleto");
        objeto.email = '';
        // if (localStorage.getItem("completado") === true) {
        //     objeto.estado_flujo = "CANCELADO"
        // } else {
        //     objeto.estado_flujo = "COMPLETADO"
        // }
        objeto.fNac = obtenerValorUser(dataUser, "nacimiento");
        objeto.curp = (hayExcepcion()) ? obtenerValorUser(dataUser, "dni") : obtenerValorUser(dataUser, "curp");
        objeto.vigencia = obtenerValorUser(dataUser, "vigencia");
        objeto.ocrFront = JSON.parse(localStorage.getItem("ocrFront")) || {};
        objeto.ocrBack = JSON.parse(localStorage.getItem("ocrBack")) || {};
        objeto.data_user = JSON.parse(localStorage.getItem("data_user")) || [];
        objeto.detailsScore = JSON.parse(localStorage.getItem('fields')) || [];
        let fecha = ""
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()
        if (month < 10) {
            fecha = `${day}0${month}${year}`
        } else {
            fecha = `${day}${month}${year}`
        }
        let partner = obtenerValorConfig(dataOtorgante, "PARTNER", "")
        partner = partner.replace(" ", "_");
        if (partner !== "") {
            partner = partner + "_"
        }
        let name_otorgante = obtenerValorConfig(dataOtorgante, "NOMBRE_CORTO", "")
        name_otorgante = name_otorgante.replace(" ", "_");
        objeto.custom_uuid = partner + name_otorgante + "_" + fecha + "_" + uuidTrx.split("-")[0];
        objeto.originOS = isIOS ? 'ios' : 'android';
        objeto.coincidencia = (dataFace.match ? "Coincide" : "Requiere validación");
        enviarCorreoAceptacion(objeto).then((response) => {
            if (response.status === 201) {
                //console.log(response);
                informacion.status = response.status;
                informacion.payload = response.data.payload;
                evento('Envío Correo', 'Success', informacion, true);
                statusData("email_check", { email: 'No se solicita correo electrónico' })
                if (regresarJson()) {
                    dataLinks()
                } else {
                    setTimeout(() => {
                        updateStatus();
                    }, 500);
                }
            }
            else {
                statusF(response.data.payload);
            }

        }).catch((error) => {
            console.error(error);
            if (error.response) {
                let { data: { message }, status } = error.response
                informacion.mensaje = message;
                informacion.status = status;
                tipo = 'Error';
            } else {
                informacion.error = error.toString();
                tipo = 'Exception';
            }
            evento('Envío Correo', tipo, informacion, false);
            statusF(error);
            if (regresarJson()) {
                dataLinks()
            } else {
                setTimeout(() => {
                    updateStatus();
                }, 500);
            }

        });
    }

    const convertdataJSON = () => {
        var fecha = ""
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()
        if (month < 10) {
            fecha = `${day}0${month}${year}`
        } else {
            fecha = `${day}${month}${year}`
        }
        var jsonObj = {};
        jsonObj.uuidUser = uuid;
        jsonObj.uuidTrx = uuidTrx;
        let partner = obtenerValorConfig(dataOtorgante, "PARTNER", "")
        partner = partner.replace(" ", "_");
        if (partner !== "") {
            partner = partner + "_"
        }
        let name_otorgante = obtenerValorConfig(dataOtorgante, "NOMBRE_CORTO", "")
        name_otorgante = name_otorgante.replace(" ", "_");
        let uuidC = partner + name_otorgante + "_" + fecha + "_" + uuidTrx.split("-")[0];
        jsonObj.custom_uuid = uuidC;
        jsonObj.ocrBack = JSON.parse(localStorage.getItem("ocrBack"));
        jsonObj.ocrFront = JSON.parse(localStorage.getItem("ocrFront"));
        jsonObj.data_user = JSON.parse(localStorage.getItem("data_user"));
        jsonObj.links = JSON.parse(localStorage.getItem('links')) || "";
        jsonObj.detailsScore = JSON.parse(localStorage.getItem('fields')) || [];
        ////console.log(res);
        return jsonObj;
    }

    const dataLinks = async () => {
        //console.log(event_t);
        let tipo = '';
        let informacion = {};
        getDocuments().then((response) => {
            informacion.status = response.status;
            informacion.payload = response.data.payload;
            evento('Obtener Documentos', 'Success', informacion, true);
            if (response.status === 200) {
                if (response.data.payload.links) {
                    let asd = JSON.stringify(response.data.payload.links)
                    localStorage.setItem('links', asd);
                }
                setTimeout(() => {
                    updateStatus();
                }, 500);
            }
        }).catch((error) => {
            if (error.response) {
                let { data: { message }, status } = error.response
                informacion.mensaje = message;
                informacion.status = status;
                tipo = 'Error';
            } else {
                informacion.error = error.toString();
                tipo = 'Exception';
            }
            evento('Obtener Documentos', tipo, informacion, false);

        })
    }

    const updateStatus = async () => {
        let res = convertdataJSON();
        let event_t = JSON.stringify(res)
        var json_final = {};
        let statu = "OK"
        if (isFlag === "YELLOW") {
            statu = "FAIL"
        }
        json_final = {
            "status": statu,
            "step": "finished",
            "description": event_t,
            "finished": true
        }
        let event = JSON.stringify(json_final);
        await sendData({ 'step': 'finalizado', 'event': event });
        // setRespuestaFinalLifeCycle(true)
        localStorage.setItem("completado", "true");
        statusFinal();
    }

    const statusFinal = () => {
        setLoading(false)
        setFinished(true)
        if (window.opener) {
            let uuidTrx = localStorage.getItem("uuidTrx");
            let event_t = "OK"

            if (regresarJson()) {
                let res = convertdataJSON();
                event_t = (res !== "") ? JSON.stringify(res) : ""
            }
            window.opener.postMessage(JSON.stringify({
                step: "completed",
                result: event_t,
                transaccion: uuidTrx,
            }), localStorage.getItem("externalReference"))
            // setRespuestaFinalPivote(true)
            // setTimeout(() => {
            //     window.close();
            // }, 1000);
        }
    }

    const actualizarScore = () => {
        let tipo = '';
        let informacion = {};
        let objeto = {createScore: true,};
        let scoreObject = JSON.parse(localStorage.getItem("scoreObject"));
        if (scoreObject != null) {
            objeto = { ...objeto, ...scoreObject}
        }
        finalUpdateScore(objeto).then((response) => {
            if (response.status === 200) {
                informacion.status = response.status;
                informacion.payload = response.data.payload;
                evento('Actualizar Score', 'Success', informacion, true);
                setTimeout(() => {
                    obtenerScoreUser();
                }, 300);
            }
        }).catch((error) => {
            if (error.response) {
                let { data: { message }, status } = error.response
                informacion.mensaje = message;
                informacion.status = status;
                tipo = 'Error';
            } else {
                informacion.error = error.toString();
                tipo = 'Exception';
            }
            evento('Actualizar Score', tipo, informacion, false);
        })
    }

    useEffect(() => {
        if (uuid && uuidTrx && isFlag && dataUser.length > 0 && dataOtorgante.length > 0 && dataFace) enviarCorreo();
    }, [uuid, uuidTrx, isFlag, dataUser, dataOtorgante, dataFace]);

    return (
        <div className="main_gradient">
            <Header ruta="finalizado" show={() => setShowHelp(true)} />
            <div className="main_text_container">
                <h1 className="animate__animated animate__fadeIn animate__delay-1s">¡Muchas gracias!</h1>
                <div className="animate__animated animate__fadeIn animate__delay-2s">
                    <p>Has concluido tu autenticación con éxito. </p>

                </div>
                {/*
                    (isFlag !== "RED") ?
                        <h1 className="animate__animated animate__fadeIn animate__delay-1s">¡Muchas Gracias!</h1>
                        :
                        <h1 className="animate__animated animate__fadeIn animate__delay-1s">Proceso no exitoso</h1>
                */}
                {/*
                    (isFlag === "GREEN") ?
                        <div className="animate__animated animate__fadeIn animate__delay-2s">
                            <p>Has completado tu validación exitosamente. </p>

                        </div>
                        :
                        (isFlag === "YELLOW") ?
                            <div className="animate__animated animate__fadeIn animate__delay-2s">
                                <p>Tu validación no fue completada exitosamente, por favor inténtalo de nuevo más tarde.</p>
                                <br />

                            </div>
                            :
                            <div className="animate__animated animate__fadeIn animate__delay-2s">
                                <p>Lo sentimos tu validación <b>no fue aceptada</b>, te sugerimos <b>verificar tu documentación</b> e intentarlo mas adelante siguiendo <b>detenidamente las instrucciones</b>.</p>
                                <br />

                            </div>

                */}
            </div>
            <p className="text-center" >Folio: <br />
                <b>{uuidTrx.split("-")[0]}</b>
            </p>
            {
                (localStorage.getItem("package") !== null) ?
                    <div className="action_buttons">
                        <a className="btn btn-raised btn-primary forcewidth100 main_bg_color animate__animated animate__delay-3s" href={"" + localStorage.getItem("package") + "://folio=" + localStorage.getItem("uuidUser")}>
                            Volver al origen
                        </a>
                    </div>
                    :
                    (!window.opener) &&
                    <div className="action_buttons">
                        <button type="button" onClick={(e) => {
                            setLoading(true)
                            setFinished(false)
                            evento('Validación de Score', 'Click', { description: 'CONTINUAR' }, true);
                            if (validarRedireccionamiento(dataOtorgante)) {
                                setLoading(false)
                                setTimeout(() => {
                                    history.push('/' + apiKey)
                                }, 300);
                            }
                        }} className="btn btn-raised btn-primary forcewidth100 main_bg_color" disabled={!finished}>CONTINUAR</button>
                    </div>
            }
            {(loading) && <Loader />}

            <Footer />
            {showHelp ? <Ayuda hide={() => setShowHelp(false)} /> : ""}
        </div>
    )
}

export default Finalizado